const csrfToken = document.querySelector("[name='csrf-token']").content

const xhr_headers = {
  'X-Requested-With': 'XMLHttpRequest', 
  'X-CSRF-Token': csrfToken
}

export default xhr_headers